import { usePageLevelEvents } from "@/hooks/usePageLevelEvents/usePageLevelEvents";
import { Product, Variant, PageConfig, FeatureFlags } from "@/types/types";

type Props = {
  product: Product;
  variant: Variant;
  pageConfig: PageConfig;
  flags?: FeatureFlags;
  isSelected: boolean;
};

export const PageLevelEvents = ({
  product,
  variant,
  pageConfig,
  flags,
  isSelected,
}: Props) => {
  usePageLevelEvents({
    product,
    variant,
    pageConfig,
    flags,
    isSelected,
  });

  return null;
};
